import React from "react";

import { SubNav } from "src/components/SubNav";
import { ariaLabel, COUNCIL_INCIDENTS_PAGE, COUNCIL_WORKS_PAGE } from "src/constants";
import { FeatureFlagNamesEnum } from "src/graphql/generated/types";
import { useHasFeatureFlagActivated } from "src/hooks";

type Props = {
  children: React.ReactNode;
};

export const CouncilServicesLayout = ({ children }: Props) => {
  const isDisplayMissionEnabled = useHasFeatureFlagActivated(
    FeatureFlagNamesEnum.CustomerPortalDisplayMissionIncidents
  );

  const links = [
    {
      label: "Travaux",
      link: COUNCIL_WORKS_PAGE,
    },
    {
      label: "Dépannage",
      link: COUNCIL_INCIDENTS_PAGE,
    },
  ];

  return (
    <div>
      {/* We already display a new "Interventions" menu entry when
        FF is enabled */}
      {!isDisplayMissionEnabled && (
        <SubNav
          links={links}
          aria-label={ariaLabel.councilServicesNavBar}
          sx={{ backgroundColor: "white" }}
        />
      )}
      <div>{children}</div>
    </div>
  );
};
